export { default } from './PatientPortalAccess';
